import React from "react";
import contactEmail from "../../assets/images/svg/contactEmail.svg";
import contactPhone from "../../assets/images/svg/contactPhone.svg";
import CardContact from "../CardContact/CardContact";

const ContactDetails = ({ name, position, emailId, phoneNum, children }) => {
  return (
    <>
      <div className="contact_person_name">
        <div>
          <h2 className="contact_name">{name}</h2>
          <p className="contact_position darkBlueTextColor">{position}</p>
        </div>
        {children && <div>{children}</div>}
      </div>

      <div>
        <div className="connect_contact_email ">
          <CardContact photo={contactEmail} type={"email"} content={emailId} />
        </div>
        <div className="connect_contact_phone ">
          <CardContact photo={contactPhone} type={"phone"} content={phoneNum} />
        </div>
      </div>
    </>
  );
};

export default ContactDetails;
